import { concatWithPrefix } from '@sravni/cosago-react-library/lib/utils';

import { pluralizeIso8601Period } from 'shared/lib';
import { formatNumber } from 'shared/lib/formatters';

import type { TCreditPurposeFormFields } from 'entities/creditForm';

export const formatCreditTitle = (data: TCreditPurposeFormFields, defaultValue?: string) => {
  const { amount, period } = data;
  let title = '';

  if (amount) {
    title = concatWithPrefix(title, `${formatNumber(Number(amount))} ₽`);
  }

  if (period) {
    title = concatWithPrefix(title, pluralizeIso8601Period(period.value), ' на ');
  }

  return title || defaultValue || '';
};
